import React from 'react';
import { Link } from 'react-router-dom';
import './Outdoor.css';

const OutDoor = () => {
  return (
    <div className="about-container">
      <header className="about-header">
        <div className="header-content">
          <h1>Embrance Nature's Beauty</h1>
          <p>"Reconnect with nature in our expansive
              outdoor spaces. Our resort's landscape
              is thoughtfully designed to offer peace
              and beauty at every corner. <br/>
              Lush green
              garden for marriage event & reception
              parties.</p>
          <h3 className='content-outdoor'>Reserve Your Perfect Venue Today, Celebrate Tomorrow!</h3>
          <Link to="/contact"><button className="explore-button" >BOOK NOW</button></Link>
        </div>
      </header>

      <div className="about-body">
        <div className="content-section">
          <div className="text-section">
            <h2>Gardens</h2>
            
            <p>Gardens are peaceful green spaces, rich in plant life, that provide a natural escape from the hustle and bustle of daily life. They are often designed to nurture 
              both visual aesthetics and environmental health, offering a perfect place for relaxation and reflection.</p>
          </div>
          <div className="image-section">
            <img src="https://res.cloudinary.com/dd8cg94ku/image/upload/v1739458830/Untitled_design_34_amkg0f.svg" alt="Garden" />
          </div>
        </div>

        <div className="content-section">
          <div className="text-section">
            <h2>Sitting Area</h2>
            <p>Outdoor sitting areas are inviting spaces designed for comfort and leisure, often featuring seating arrangements like benches, chairs, or swings. They provide a tranquil environment for enjoying nature, socializing, or simply unwinding in the open air.

</p>
          </div>
          <div className="image-section">
            <img src="https://res.cloudinary.com/dd8cg94ku/image/upload/v1735985991/3_qxxaro.svg" alt="Decor" />
          </div>
        </div>

        <div className="content-section">
          <div className="text-section">
            <h2>Scenic Outlook </h2>
            <p>A scenic outlook is a designated spot that provides a stunning panoramic view of natural landscapes, cityscapes, or other breathtaking surroundings. It offers a tranquil place to pause, take in the beauty of the environment, and enjoy moments of reflection. Whether overlooking mountains, 
              oceans, or gardens, it serves as a perfect vantage point for appreciating nature's splendor.</p>
          </div>
          <div className="image-section">
            <img src="https://res.cloudinary.com/dd8cg94ku/image/upload/v1739458828/Untitled_design_35_jhjtn0.svg" alt="outlook" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OutDoor;
